import { GenericValue } from 'hisng';

export class ImportRun {

    // import source type: ORCID or BibTeX
    importSourceValue: GenericValue;

    // import source
    importSource: string;


    constructor() { }

}
